/**
 * Error boundary fallback component
 * Displayed when React encounters an unrecoverable error
 */
export const ErrorFallback = ({ 
  error, 
  resetError 
}: { 
  error: unknown
  componentStack: string
  eventId: string
  resetError: () => void
}): JSX.Element => {
  const errorMessage = error instanceof Error ? error.message : 'An unexpected error occurred'
  
  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      fontFamily: 'system-ui',
      padding: '20px'
    }}>
      <div style={{ textAlign: 'center', maxWidth: '600px' }}>
        <h1 style={{ color: '#dc2626', marginBottom: '16px' }}>Something went wrong</h1>
        <p style={{ color: '#4b5563', marginBottom: '24px' }}>
          {errorMessage}
        </p>
        <button 
          onClick={resetError}
          style={{
            backgroundColor: '#2563eb',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Try again
        </button>
      </div>
    </div>
  )
}
